import React from 'react';
import { connect } from 'react-redux';
import { PersistentMenuItem } from 'eymp-uicomps/components/PersistentMenu';
import AccordionPanel from '../AccordionPanel/AccordionPanel';
import StatusIcon from '../../../assets/dashboardIcons/StatusIcon.png';
import CheckIcon from '../../../assets/dashboardIcons/CheckIcon.png';
import { CASE_DATA_COLLECT_COMPOSE_URL, TASK_STATUS } from 'src/constants/constants';
import { generatePath } from 'react-router';
import { fetchCaseMenu } from 'src/services/questionnaire.service';
import { fnGetCaseRelatedId, fnSetIsAllCaseToggle, fnGetIsAllCaseToggle } from 'src/helpers/commonFunctions';
import { formatDate } from 'src/helpers/date';
import {
  setCaseDetail,
  setCaseSubmitted,
  setReloadOnToggleChange,
  setRefreshPageStatus,
} from 'src/new-ui/features/CaseDataCollect/state/caseDataCollectAction';
import ToggleWithLabels from '../ToggleWithLabels';
import { isApplicantSelector } from 'src/ui/features/Login/state/loginReselect';
import Spinner from 'src/ui/library/Spinner/Spinner';
import _ from 'lodash';
import intl from 'react-intl-universal';
import { Divider } from '@material-ui/core';
import DisabledMenu from '../CaseDataDisabledMenu/CaseDataDisabledMenu';
import { withSnackbar } from 'notistack';

class CaseDataLeftPanel extends React.Component {
  state = {
    menuData: null,
    caseId: null,
    pageId: null,
    isToggleOn: fnGetIsAllCaseToggle(),
    showSpinner: true,
  };
  selectedPageId = '';
  componentDidMount() {
    this.getCaseMenu();
  }
  componentDidUpdate() {
    if (this.props.reviewSubmit) {
      this.getCaseMenu(null, true);
      this.props.setCaseSubmitted(false);
    }
    if (this.props.reloadOnToggleChange) {
      let linkButtons = document.getElementsByClassName('link-button');
      if (linkButtons && linkButtons.length > 0) {
        _.first(linkButtons).click();
        this.props.setReloadOnToggleChange(false);
      }
    }
    if (this.props.refreshPage) {
      this.setState({ menuData: this.props.caseDatacollectMenu });
      this.props.setRefreshPageStatus(false);
    }
  }

  getCaseMenu = (toggleChange, isOnUpdate) => {
    let caseId = fnGetCaseRelatedId(2);
    let pageId = fnGetCaseRelatedId(4);
    if (caseId) {
      this.selectedPageId = '';
      let isAllCases = this.props.isApplicant ? null : fnGetIsAllCaseToggle();
      return new Promise(async (resolve, reject) => {
        let response = await fetchCaseMenu(caseId, isAllCases);
        if (response) {
          this.selectedPageId = _.first(response) ? _.first(_.first(response).subMenu).pageId : '';
          this.setState({ menuData: response, caseId: caseId, pageId: pageId, showSpinner: false });
          this.props.setCaseDetail(response, isOnUpdate);
          resolve({ toggleChange });
        }
      }).then(result => {
        if (result.toggleChange) {
          this.props.setReloadOnToggleChange(true);
        }
      });
    }
  };

  isCollapsible = menu => {
    // if (menu.menuTypeCode !== 1) {
    return menu.subMenu.filter(x => x.pageState.toLowerCase() !== 'complete').length > 0;
    // }
    // return menu.pageId === fnGetCaseRelatedId(3);
  };

  isPanelDisabled = (menu, ind) => {
    return (
      !menu.isActive || (menu.subMenu.length === ind + 1 && menu.subMenu.filter(x => x.pageState.toLowerCase() !== 'complete').length > 1)
    );
  };
  handleOnToggle = flag => {
    fnSetIsAllCaseToggle(flag);
    this.setState({ isToggleOn: flag, showSpinner: true });
    this.getCaseMenu(true);
  };
  getMenuName({ menuName }, length) {
    if (!length) return menuName;
    return menuName ? (menuName.length > length ? _.join(_.take(menuName, length), '') + '..' : menuName) : '';
  }

  getCaseMenuComponent(menuData, caseId) {
    if (menuData !== null && menuData.length === 0) {
      return <div className="color-white mrg-22">{intl.get('newDashboard.common.noItemtoDisplay')}</div>;
    }
    return (
      <div>
        {menuData &&
          menuData.length > 0 &&
          menuData.map((menu, index) => (
            <AccordionPanel
              isOpen={this.isCollapsible(menu)}
              dataTitle1={this.getMenuName(menu, 40)}
              dataTitle1ToolTip={this.getMenuName(menu)}
              dataTitle2={menu.menuTypeCode === 1 ? 'Due date: ' + (menu.dueDate ? formatDate(menu.dueDate) : 'NA') : ''}>
              <div className="active-menu">
                {menu.subMenu.map((subMenu, ind) =>
                  menu.menuTypeCode === 1 && !menu.isActive ? (
                    <DisabledMenu subMenu={subMenu} {...this.props}></DisabledMenu>
                  ) : (
                    <PersistentMenuItem
                      route={generatePath(CASE_DATA_COLLECT_COMPOSE_URL + '/' + caseId + '/' + menu.pageId + '/' + subMenu.pageId)}
                      className={menu.menuTypeCode === 1 && this.isPanelDisabled(menu, ind) ? 'menu-disabled' : ''}
                      label={
                        <div>
                          <Divider orientation="vertical" className="vertical-line-active-menu" />
                          <div className="label-name">
                            <div className="status-img">
                              <img src={subMenu.pageState.toLowerCase() === 'complete' ? CheckIcon : StatusIcon} />
                            </div>

                            <div className="d-grid">
                              <span>{subMenu.menuName}</span>
                              <span>
                                {(subMenu.pageState.toLowerCase() === 'complete' ? TASK_STATUS.COMPLETED : TASK_STATUS.OPEN) +
                                  (menu.menuTypeCode !== 1 ? ' | Due date: ' + (subMenu.dueDate ? formatDate(subMenu.dueDate) : 'NA') : '')}
                              </span>
                              {this.state.isToggleOn && (
                                <span className="font-10">{this.props.isApplicant ? '' : 'Assigned to: ' + subMenu.taskAssignedTo}</span>
                              )}
                            </div>
                          </div>
                        </div>
                      }
                    />
                  ),
                )}
              </div>
            </AccordionPanel>
          ))}
      </div>
    );
  }
  render() {
    let { menuData, caseId } = this.state;
    return (
      menuData && (
        <div className="data-left-panel">
          {!this.props.isApplicant && (
            <div className="case-toggle">
              <ToggleWithLabels
                onLabel="All actions"
                offLabel="My actions"
                switchSelected={this.state.isToggleOn}
                onChange={e => this.handleOnToggle(e)}
              />
            </div>
          )}
          {this.state.showSpinner ? (
            <div style={{ marginTop: '10%', marginBottom: '10%' }}>
              <Spinner size={50} />
            </div>
          ) : (
            this.getCaseMenuComponent(menuData, caseId)
          )}
        </div>
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    reviewSubmit: state.caseDatacollectMenu.reviewSubmit,
    isApplicant: isApplicantSelector(state),
    reloadOnToggleChange: state.caseDatacollectMenu.reloadOnToggleChange,
    caseDatacollectMenu: state.caseDatacollectMenu.menuDetails,
    refreshPage: state.caseDatacollectMenu.refreshPage,
  };
};
const mapDispatchToProps = {
  setCaseDetail,
  setReloadOnToggleChange,
  setCaseSubmitted,
  setRefreshPageStatus,
};
export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(CaseDataLeftPanel));
